(() => {
  // app/scripts/facets.js
  var FilterDrawer = class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
      this.getElementsByClassName("js-popup-close").addEvents("click", this.close.bind(this));
      this.focusTrap = window.focusTrap.createFocusTrap(this, {
        escapeDeactivates: false
      });
      this.setTriggerButtonAccessibility();
      Popups.push("filter-drawer", this);
    }
    setTriggerButtonAccessibility() {
      const triggerButtons = document.querySelectorAll(".toolbar .trigger-button");
      triggerButtons.forEach((button) => {
        button.setAttribute("aria-haspopup", "dialog");
        button.addEventListener("click", (event) => {
          event.preventDefault();
          this.open();
        });
        button.addEventListener("keydown", (event) => {
          if (event.code.toUpperCase() === "SPACE") {
            event.preventDefault();
            this.open();
          }
        });
      });
    }
    close() {
      this.removeClass("is-open");
      AT.enableScroll();
      this.focusTrap.deactivate();
    }
    open() {
      this.addClass("is-open");
      AT.disableScroll();
      setTimeout(() => {
        this.focusTrap.activate();
      }, 600);
    }
  };
  customElements.define("filter-drawer", FilterDrawer);
  var FacetedSearchFiltering = class extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      this.settings = JSON.parse(this.querySelector("script[data-facets-settings]").innerHTML);
      if (!this.settings.enableFiltering && !this.settings.enableSorting)
        return;
      this.elms = {
        maxlistMore: this.getElementsByClassName("maxlist-more"),
        maxlistLess: this.getElementsByClassName("maxlist-less")
      };
      this.filterData = [];
      this.searchParamsInitial = window.location.search.slice(1);
      this.searchParamsPrev = window.location.search.slice(1);
      this.sectionID = this.dataset.id;
      this.initmaxlist();
      this.bindEvents();
      this.setDetailsElementsAccessibility();
    }
    disconnectedCallback() {
      window.removeEventListener("popstate", this.onHistoryChange);
    }
    onKeyUpEscape(event) {
      if (event.code.toUpperCase() !== "ESCAPE")
        return;
      const openDetailsElement = event.target.closest("details[open]");
      if (!openDetailsElement)
        return;
      const summaryElement = openDetailsElement.querySelector("summary");
      openDetailsElement.removeAttribute("open");
      summaryElement.setAttribute("aria-expanded", false);
      summaryElement.focus();
    }
    setDetailsElementsAccessibility() {
      this.querySelectorAll("details.js-filter, details.js-sorting-mobile").forEach((details) => {
        const summary = details.querySelector("summary");
        summary.setAttribute("role", "button");
        summary.setAttribute("aria-expanded", details.hasAttribute("open"));
        if (summary.nextElementSibling.getAttribute("id")) {
          summary.setAttribute("aria-controls", summary.nextElementSibling.id);
        }
        summary.addEventListener("click", (event) => {
          summary.setAttribute("aria-expanded", !details.hasAttribute("open"));
        });
        details.addEventListener("keyup", this.onKeyUpEscape);
      });
    }
    bindEvents() {
      const debouncedOnChange = AT.debounce((event) => {
        this.onSubmitHandler(event);
      }, 300);
      this.addEventListener("change", debouncedOnChange.bind(this));
      this.onHistoryChange = (event) => {
        const searchParams = event.state ? event.state.searchParams : this.searchParamsInitial;
        if (searchParams === this.searchParamsPrev)
          return;
        this.renderPage(searchParams, null, false);
      };
      window.addEventListener("popstate", this.onHistoryChange);
      this.onApplyButtonClick();
    }
    renderPage(searchParams, event, updateURLHash = true) {
      this.searchParamsPrev = searchParams;
      const url = `${window.location.pathname}?section_id=${this.sectionID}${searchParams && "&".concat(searchParams)}`;
      const filterDataUrl = (element) => element.url === url;
      this.filterData.some(filterDataUrl) ? this.renderSectionFromCache(filterDataUrl, event) : this.renderSectionFromFetch(url, event);
      if (updateURLHash)
        this.updateURLHash(searchParams);
    }
    renderSectionFromFetch(url, event) {
      fetch(url, { dataType: "text" }).then((text) => {
        const parsedHTML = new DOMParser().parseFromString(text, "text/html");
        this.filterData = [...this.filterData, { text, url }];
        this.renderHTML(parsedHTML, event);
      });
    }
    renderSectionFromCache(filterDataUrl, event) {
      const html = this.filterData.find(filterDataUrl).text;
      const parsedHTML = new DOMParser().parseFromString(html, "text/html");
      this.renderHTML(parsedHTML, event);
    }
    renderHTML(html, event) {
      this.renderPageTitle(html);
      this.renderFilters(html, event);
      this.renderSortingElements(html);
      this.renderProductGridContainer(html);
      this.setDetailsElementsAccessibility();
    }
    renderPageTitle(html) {
      if (html.querySelector("faceted-search-filtering").dataset.title) {
        document.title = html.querySelector("faceted-search-filtering").dataset.title;
      }
    }
    renderFilters(html, event) {
      const sourceDetailsElements = html.querySelectorAll("details.js-filter");
      const targetDetailsElements = document.querySelectorAll("details.js-filter");
      const targetID = event && event.target.id;
      targetDetailsElements.forEach((element, index) => {
        element.outerHTML = sourceDetailsElements[index].outerHTML;
      });
      this.renderActiveFacets(html);
      this.initmaxlist();
      this.onApplyButtonClick();
      requestAnimationFrame(() => {
        if (!targetID || !document.querySelector(`#${targetID}`))
          return;
        const targetElement = document.querySelector(`#${targetID}`);
        if (!!targetElement.closest("details.filter-group")) {
          targetElement.closest("details.filter-group").querySelector("summary").focus();
        }
      });
    }
    renderSortingElements(html) {
      const sortingElementSelectors = [".js-sorting-mobile", ".js-sorting-desktop"];
      sortingElementSelectors.forEach((selector) => {
        const sortingElement = html.querySelector(selector);
        if (!sortingElement)
          return;
        document.querySelector(selector).outerHTML = sortingElement.outerHTML;
      });
    }
    renderProductGridContainer(html) {
      document.querySelector("#product-grid").innerHTML = html.querySelector("#product-grid").innerHTML;
    }
    renderActiveFacets(html) {
      const activeFacetElementSelectors = [".js-active-facets"];
      this.classList.add("test");
      activeFacetElementSelectors.forEach((selector) => {
        const activeFacetsElement = html.querySelector(selector);
        if (!activeFacetsElement)
          return;
        const currentElement = document.querySelector(selector);
        if (!currentElement)
          return;
        currentElement.innerHTML = activeFacetsElement.innerHTML;
        currentElement.classList.toggle("hidden", !currentElement.querySelector("facet-remove"));
      });
    }
    updateURLHash(searchParams) {
      history.pushState({ searchParams }, "", `${window.location.pathname}${searchParams && "?".concat(searchParams)}`);
    }
    onSubmitHandler(event) {
      event.preventDefault();
      if (event.target.type == "range" || event.target.type == "number")
        return;
      if (event.target.name == "sort_by" && event.target.tagName == "SELECT") {
        this.querySelector(`input[name=sort_by][value=${event.target.value}]`).checked = true;
      }
      const filtersForm = this.querySelector(".js-filters-form");
      const forms = [];
      forms.push(AT.getParameterByName("q") ? `q=${AT.getParameterByName("q")}` : "");
      forms.push(this.createSearchParams(filtersForm));
      const searchParams = forms.filter(Boolean).join("&");
      this.renderPage(searchParams, event);
    }
    createSearchParams(form) {
      const formData = new FormData(form);
      return new URLSearchParams(formData).toString();
    }
    initmaxlist() {
      let { maxlistMore, maxlistLess } = this.elms;
      maxlistMore.forEach((e) => {
        e.addEvent("click", function() {
          let filterMax = this.closest(".filter-maxlist");
          this.addClass("d-none");
          this.closest(".filter-group__panel").addClass("maxlist-more-active");
          this.closest(".filter-group__panel").previousElementSibling.focus();
          filterMax.querySelector(".maxlist-less").removeClass("d-none");
        });
      });
      maxlistLess.forEach((e) => {
        e.addEvent("click", function() {
          let filterMax = this.closest(".filter-maxlist");
          this.addClass("d-none");
          this.closest(".filter-group__panel").removeClass("maxlist-more-active");
          this.closest(".filter-group__panel").previousElementSibling.focus();
          filterMax.querySelector(".maxlist-more").removeClass("d-none");
        });
      });
    }
    onActiveFilterClick(event) {
      event.preventDefault();
      const searchParams = event.currentTarget.href.indexOf("?") == -1 ? "" : event.currentTarget.href.slice(event.currentTarget.href.indexOf("?") + 1);
      this.renderPage(searchParams);
    }
    onApplyButtonClick() {
      if (!this.querySelector(".range-slider__submit .filter-price-button"))
        return;
      this.querySelector(".range-slider__submit .filter-price-button").addEventListener("click", (e) => {
        this.onSubmitHandler(e);
      });
    }
  };
  customElements.define("faceted-search-filtering", FacetedSearchFiltering);
  var FacetRemove = class extends HTMLElement {
    constructor() {
      super();
      const facetLink = this.querySelector("a");
      facetLink.setAttribute("role", "button");
      facetLink.addEventListener("click", this.closeFilter.bind(this));
      facetLink.addEventListener("keydown", (event) => {
        if (event.code.toUpperCase() === "SPACE")
          event.preventDefault();
      });
      facetLink.addEventListener("keyup", (event) => {
        event.preventDefault();
        if (event.code.toUpperCase() === "SPACE")
          this.closeFilter(event);
      });
    }
    closeFilter(event) {
      event.preventDefault();
      const form = this.closest("faceted-search-filtering");
      form.onActiveFilterClick(event);
    }
  };
  customElements.define("facet-remove", FacetRemove);
  var PriceRange = class extends HTMLElement {
    constructor() {
      super();
      this.inputs = this.querySelectorAll("input");
      this.linkedInputs = this.closest("details").querySelectorAll("range-slider input");
      this.progressBar = this.closest("details").querySelector("range-slider .progress");
      this.inputs.forEach((element) => {
        element.addEventListener("change", this.onRangeChange.bind(this));
      });
      this.setMinAndMaxValues();
    }
    onRangeChange(event) {
      this.adjustToValidValues(event.currentTarget);
      this.setMinAndMaxValues();
      this.adjustRangeSliderValues();
    }
    adjustRangeSliderValues() {
      this.linkedInputs[0].value = this.inputs[0].value ? parseFloat(this.inputs[0].value) : parseFloat(this.inputs[0].min);
      this.linkedInputs[1].value = this.inputs[1].value ? parseFloat(this.inputs[1].value) : parseFloat(this.inputs[1].max);
      this.progressBar.style.setProperty("--left", parseFloat(this.linkedInputs[0].value) * 100 / parseFloat(this.linkedInputs[0].max) + "%");
      this.progressBar.style.setProperty("--right", 100 - parseFloat(this.linkedInputs[1].value) * 100 / parseFloat(this.linkedInputs[1].max) + "%");
    }
    setMinAndMaxValues() {
      const minInput = this.inputs[0];
      const maxInput = this.inputs[1];
      if (maxInput.value)
        minInput.setAttribute("max", maxInput.value);
      if (minInput.value)
        maxInput.setAttribute("min", minInput.value);
      if (minInput.value === "")
        maxInput.setAttribute("min", 0);
      if (maxInput.value === "")
        minInput.setAttribute("max", maxInput.getAttribute("max"));
    }
    adjustToValidValues(input) {
      const value = Number(input.value);
      const min = Number(input.getAttribute("min"));
      const max = Number(input.getAttribute("max"));
      if (value < min)
        input.value = min;
      if (value > max)
        input.value = max;
    }
  };
  customElements.define("price-range", PriceRange);
  var RangeSlider = class extends HTMLElement {
    constructor() {
      super();
      this.progressBar = this.querySelector(".progress");
      this.inputs = this.querySelectorAll("input");
      this.linkedInputs = this.closest("details").querySelectorAll("price-range input");
      this.inputs.forEach((input) => {
        input.addEventListener("input", this.onInput.bind(this));
        input.addEventListener("change", this.onChange.bind(this));
      });
    }
    onInput(event) {
      event.stopPropagation();
      let slide1 = parseFloat(this.inputs[0].value), slide2 = parseFloat(this.inputs[1].value);
      if (slide1 > slide2) {
        [slide1, slide2] = [slide2, slide1];
      }
      this.linkedInputs[0].value = slide1;
      this.linkedInputs[1].value = slide2;
      this.progressBar.style.setProperty("--left", slide1 * 100 / parseFloat(this.inputs[0].max) + "%");
      this.progressBar.style.setProperty("--right", 100 - slide2 * 100 / parseFloat(this.inputs[1].max) + "%");
    }
    onChange(event) {
      this.linkedInputs[0].dispatchEvent(new Event("change"));
      this.linkedInputs[1].dispatchEvent(new Event("change"));
    }
  };
  customElements.define("range-slider", RangeSlider);
  console.log("facets.js loaded");
})();
